import { render, staticRenderFns } from "./createSecretConfirmSMS.popup-chunk.vue?vue&type=template&id=04fafdbf&scoped=true"
import script from "./createSecretConfirmSMS.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./createSecretConfirmSMS.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./createSecretConfirmSMS.popup-chunk.vue?vue&type=style&index=0&id=04fafdbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fafdbf",
  null
  
)

export default component.exports